<ng-container [formGroup]="formGroup">
  <mat-form-field class="field">
    <label>
      <input [formControlName]="controlName" matInput
        [id]="controlName"
        [placeholder]="getTooltip()" type="text"
        (blur)="onBlur()" (focus)="onFocus()">
    </label>
    @if (showValid && formGroup.get(controlName).valid && isFocused()) {
      <button mat-button matSuffix mat-icon-button>
        <mat-icon class="valid-input">done</mat-icon>
      </button>
    }
    @if (formGroup.get(controlName).invalid && formGroup.get(controlName).dirty) {
      <button mat-button matSuffix
        mat-icon-button>
        <mat-icon class="invalid-input">error</mat-icon>
      </button>
    }

    <!-- Cannot use ngFor due to issues in mat-error implementation if nested under a different tag -->
    @if (errorDetected(0)) {
      <mat-error>
        {{errorMessage(0) | async}}
      </mat-error>
    }
    @if (errorDetected(1)) {
      <mat-error>
        {{errorMessage(1) | async}}
      </mat-error>
    }
    @if (errorDetected(2)) {
      <mat-error>
        {{errorMessage(2) | async}}
      </mat-error>
    }
    @if (errorDetected(3)) {
      <mat-error>
        {{errorMessage(3) | async}}
      </mat-error>
    }
  </mat-form-field>
</ng-container>
